import { combineReducers } from 'redux';
import { routerReducer as routing } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';
import usersReducer from './reducers/usersReducer';
import purgedUsersReducer from './reducers/purgedUsersReducer';
import adminsReducer from './reducers/adminsReducer';
import loginReducer from './reducers/loginReducer';
import commonReducer from './reducers/commonReducer';
import bulkActionsReducer from './reducers/bulkActionsReducer';
import singleActionsReducer from './reducers/singleActionsReducer';
import featuresReducer from './reducers/featuresReducer';
import eventsReducer from './reducers/eventsReducer';

export default combineReducers({
  routing,
  usersReducer,
  purgedUsersReducer,
  loginReducer,
  commonReducer,
  bulkActionsReducer,
  singleActionsReducer,
  featuresReducer,
  adminsReducer,
  eventsReducer,
  form: formReducer,
});
